// La barra de estados: una franja segmentada encima de la tabla con cuántas
// cargas hay en cada uno de los nueve estados. Es el resumen que dirección
// quería ver de un vistazo y, a la vez, un filtro: pulsar un segmento lo
// añade o lo quita del filtro de estado.
//
// Cuenta sobre la CASCADA (las cargas que pasan todos los filtros menos el de
// estado), y por eso no se encoge al elegir un segmento: los demás siguen ahí,
// atenuados, para poder cambiar de opinión.
import { useTranslation } from 'react-i18next'
import type { CargaSalida, EstadoCarga } from '@/types'
import { ESTADO_CHIP, alternarEstado, segmentosEstado } from '@/utils/cargasSalida'

interface Props {
  dark: boolean
  /** Cargas que pasan todos los filtros EXCEPTO el de estado. */
  cargas: readonly CargaSalida[]
  seleccion: readonly EstadoCarga[]
  onChange: (estados: EstadoCarga[]) => void
}

export function BarraEstados({ dark, cargas, seleccion, onChange }: Props) {
  const { t } = useTranslation()
  const segmentos = segmentosEstado(cargas)
  if (segmentos.length === 0) return null
  const hayElegidos = seleccion.length > 0

  return (
    <div
      role="group"
      aria-label={t('cargasSalida.estadoCarga.barra.titulo')}
      className="flex w-full gap-0.5 overflow-hidden rounded-lg"
    >
      {segmentos.map(({ estado, cantidad }) => {
        const activo = seleccion.includes(estado)
        const etiqueta = t('cargasSalida.estadoCarga.barra.segmento', {
          estado: t(`cargasSalida.estadoCarga.${estado}`), count: cantidad,
        })
        return (
          <button
            key={estado}
            type="button"
            aria-pressed={activo}
            title={t(`cargasSalida.estadoCarga.${estado}Tooltip`)}
            onClick={() => onChange(alternarEstado(seleccion, estado))}
            // Ancho proporcional a las cargas, con un mínimo para que el
            // rótulo de un estado pequeño no se corte hasta lo ilegible.
            style={{ flexGrow: cantidad, flexBasis: 0, minWidth: 96 }}
            className={`px-2 py-1.5 text-left text-[11px] font-bold whitespace-nowrap truncate cursor-pointer transition-opacity ${
              dark ? ESTADO_CHIP[estado].dark : ESTADO_CHIP[estado].light
            } ${hayElegidos && !activo ? 'opacity-40 hover:opacity-80' : ''} ${
              activo ? 'ring-2 ring-inset ring-white/80' : ''
            }`}
          >
            {etiqueta}
          </button>
        )
      })}
    </div>
  )
}
